import React from 'react';
import EntityContentType from '@/constants/EntityContentType';
import CampaignMenu from './CampaignMenu';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import DonationMenu from './DonationMenu';
import EmailIntegrationMenu from './EmailIntegrationMenu';
import EntityDetailsFooter from './EntityDetailsFooter';
import InteractionMenu from './InteractionMenu';
import TaskMenu from './TaskMenu';

type ContentFooterProps = {
  contentType?: string;
  entity: object;
  mutate(...args: unknown[]): unknown;
  onDelete(...args: unknown[]): unknown;
};

/**
 * @deprecated this should be replaced with composing the entity details
 * using the entity detail components, much like <OpportunityDetailsContent>
 */
function ContentFooter({
  contentType,
  entity,
  mutate,
  onDelete,
}: ContentFooterProps) {
  // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'created' does not exist on type '{}'.
  const { created, createdBy, updated, updatedBy } = entity;

  const menu = React.useMemo(() => {
    switch (contentType) {
      case EntityContentType.DONATION:
        // @ts-expect-error TS(2322) TODO(ts-migrate): Type 'object' is not assignable to type 'InferProp... Remove this comment to see the full error message
        return <DonationMenu donation={entity} />;
      case EntityContentType.CAMPAIGN:
      case EntityContentType.CAMPAIGN_CREATED:
      case EntityContentType.CAMPAIGN_GOAL_MET:
      case EntityContentType.CAMPAIGN_STRETCH_GOAL_MET:
        // @ts-expect-error TS(2322) TODO(ts-migrate): Type 'object' is not assignable to type 'InferProp... Remove this comment to see the full error message
        return <CampaignMenu campaign={entity} />;
      case EntityContentType.EMAIL_RECEIVED:
      case EntityContentType.EMAIL_SENT:
        return <EmailIntegrationMenu email={entity} />;
      case EntityContentType.INTERACTION:
        return <InteractionMenu interaction={entity as Interaction} />;
      case EntityContentType.TASK:
        // @ts-expect-error TS(2322) TODO(ts-migrate): Type '{ onDelete: (...args: unknown[]) => unknown;... Remove this comment to see the full error message
        return <TaskMenu onDelete={onDelete} onSave={mutate} task={entity} />;
      default:
        return null;
    }
  }, [contentType, entity]);

  return (
    <EntityDetailsFooter
      created={created}
      createdBy={createdBy}
      updated={updated}
      updatedBy={updatedBy}
    >
      {menu}
    </EntityDetailsFooter>
  );
}

ContentFooter.defaultProps = {
  contentType: null,
};

export default ContentFooter;
